import { Component, Input } from '@angular/core';
import { Notificacao } from './notifications.interface';
import { DateUtilsService } from 'src/app/modules/shared/services/date-utils/date-utils.service';
import { UserService } from 'src/app/modules/usuario/service/user.service';
import { BehaviorSubject, Subscription, take } from 'rxjs';
import { ToastService } from 'src/app/modules/shared/services/toast/toast.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent {
  @Input() notifications: Notificacao[] = [];
  @Input() viewMoreNotifications!: (pageNumber: number) => void;
  @Input() lastPage$!: BehaviorSubject<boolean>;
  @Input() isFetching$!: BehaviorSubject<boolean>;

  isFetching: boolean = false;
  lastPage: boolean = false;
  private lastPageSub?: Subscription;
  private isFetchingSub?: Subscription;

  subscriptions: Subscription[] = [];
  notificationsToShowDetails: string[] = [];
  pageNumber: number = 0;

  constructor(
    private userService: UserService,
    private dateUtilsService: DateUtilsService,
    private toastService: ToastService,
  ) {}

  ngOnInit() {
    this.lastPageSub = this.lastPage$.subscribe((val) => {
      this.lastPage = val;
    });

    this.isFetchingSub = this.isFetching$.subscribe((val) => {
      this.isFetching = val;
    });
  }

  formatDate(dateStr: string) {
    return this.dateUtilsService.formatNotificationDate(dateStr);
  }

  onDetails(id: string) {
    if (this.notificationsToShowDetails.includes(id)) {
      this.notificationsToShowDetails = this.notificationsToShowDetails.filter(
        (notificationId) => notificationId !== id,
      );
    } else {
      this.notificationsToShowDetails.push(id);
    }
  }

  isDetailsOpen(id: string) {
    return this.notificationsToShowDetails.includes(id);
  }

  markAsRead(notification: Notificacao) {
    if (notification.lida) return;

    this.subscriptions.push(
      this.userService
        .markNotificationAsRead(notification.id, notification.tipoNotificacao)
        .pipe(take(1))
        .subscribe({
          next: () => {
            notification.lida = true;
          },
          error: (erro: any) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          },
        }),
    );
  }

  viewMore() {
    if (this.isFetching) return;

    this.viewMoreNotifications(this.pageNumber + 1);
    this.pageNumber++;
  }

  keepOriginalOrder = (a: any, b: any): number => {
    return 0;
  };

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.lastPageSub?.unsubscribe();
    this.isFetchingSub?.unsubscribe();
  }
}
